import { useEffect, useState } from 'react';
import { ReactComponent as CoinIcon } from 'src/assets/icons/bonus-game/coin.svg';
import { ReactComponent as MedalGold } from 'src/assets/icons/bonus-game/medal-gold.svg';
import { ReactComponent as MedalSilver } from 'src/assets/icons/bonus-game/medal-silver.svg';
import { ReactComponent as MedalBronze } from 'src/assets/icons/bonus-game/medal-bronze.svg';
import { ReactComponent as MedalRegular } from 'src/assets/icons/bonus-game/medal.svg';
import { ReactComponent as ShareIcon } from 'src/assets/icons/bonus-game/share-icon.svg';
import { HorizontalView, VerticalView } from 'src/components/FlexViews';

import { bonusGameApi } from 'src/api/bonus-game';
import { useInView } from 'react-intersection-observer';
import { BonusTreeInfoDto, UserPositionBySeasonDto } from 'src/api/Api';
import Loader from 'src/pages/Education/components/Loader';
import { TabValue } from '../../types';
import {
  BonusAmount,
  GamerName,
  InviteButton,
  Label,
  LeaderBoardWrapper,
  MedalPosition,
  MedalWrapper,
  NoReferralsDescription,
  NoReferralsTitle,
  NoReferralsWrapper,
  PlayerRowItemWrapper,
} from './styled';
import { Promocode } from 'src/pages/BonusGame/components/Promocode';

const medalIcons = [
  <MedalGold key={'gold'}/>,
  <MedalSilver key={'silver'}/>,
  <MedalBronze key={'bronze'}/>,
];

const getMedalIcon = (position: number) => {
  if (position > 3) {
    return <MedalRegular/>;
  }
  return medalIcons[position - 1];
};

export const LeaderBoard = ({ activeTab }: { activeTab: TabValue }) => {
  const [data, setData] = useState<BonusTreeInfoDto[]>([]);
  const [promoCode, setPromoCode] = useState('');
  const [loading, setLoading] = useState(true);
  const [userPoistion, setUserPoisition] = useState<UserPositionBySeasonDto>();

  useEffect(() => {
    (async () => {

      try {

        const leaderBoardReqObj: any = {};
        const userPosReqObj: any = {};
        let promoCodeValue;
        try {
          const promocodeRes = await bonusGameApi.generateInviteCode();
          promoCodeValue = promocodeRes.result.promoCode;
        } catch (e) {
          console.log('error loading promocode', e);
        }

        if (activeTab === TabValue.CurrentSeason) {
          leaderBoardReqObj.seasonId = 2;
          userPosReqObj.seasonId = 2;
        } else if (activeTab === TabValue.Referrals && promoCodeValue) {
          leaderBoardReqObj.promoCode = promoCodeValue;
        }
        const userPositionRes = await bonusGameApi.getPositionBySeason({
          ...userPosReqObj,
        });
        const leaderBoardResponse = await bonusGameApi.getLeaderBoard({
          pagination: {
            take: 25,
            skip: 0,
          },
          ...leaderBoardReqObj,
        });
        console.log('res', leaderBoardResponse);
        setUserPoisition(userPositionRes.result);
        if (promoCodeValue) {
          setPromoCode(promoCodeValue);
        }
        setData(leaderBoardResponse.result);
      } catch (e) {
        console.log('err', e);
      } finally {
        setLoading(false);
      }
    })();
  }, [activeTab]);

  const fetchMoreData = async () => {
    const currentItemsLength = data.length;
    const leaderBoardReqObj: any = {};

    if (activeTab === TabValue.CurrentSeason) {
      leaderBoardReqObj.seasonId = 2;
    } else if (activeTab === TabValue.Referrals) {
      if (!promoCode) return;
      leaderBoardReqObj.promoCode = promoCode;
    }
    const leaderBoardResponse = await bonusGameApi.getLeaderBoard({
      pagination: {
        take: 25,
        skip: currentItemsLength,
      },
      ...leaderBoardReqObj,
    });
    setData(prev => [...prev, ...leaderBoardResponse.result]);
  };

  const loadMoreData = (inView: boolean) => {
    if (inView) {
      fetchMoreData();
    }
  };

  const { ref } = useInView({
    threshold: 0,
    initialInView: false,
    onChange: loadMoreData,
    triggerOnce: true,
  });

  if (loading || !userPoistion) return <Loader small/>;

  const handleInviteFriends = () => {
    (window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'share-popup',
        data: {
          message: `Join me on Haqabi Tree game using my promo code ${promoCode}`,
        },
      }),
    );
  };
  return (
    <LeaderBoardWrapper>
      {activeTab === TabValue.Referrals && data.length === 0 ? (
        <NoReferralsWrapper>
          <NoReferralsTitle>No referrals here yet</NoReferralsTitle>
          <NoReferralsDescription>
            Earn rewards by inviting your friends!
          </NoReferralsDescription>
          <Promocode promoCode={promoCode}/>
          <InviteButton onClick={handleInviteFriends}>
            <ShareIcon/>
            Invite Friends
          </InviteButton>
        </NoReferralsWrapper>
      ) : (
        <>
          {activeTab !== TabValue.Referrals && (
            <VerticalView style={{ marginBottom: 8, gap: 8 }}>
              <Label>My position</Label>
              {!loading && <PlayerRowItem gamer={userPoistion}/>}
            </VerticalView>
          )}
          <VerticalView style={{ gap: 8 }}>
            <Label>Top players</Label>

            {data.map((gamer, idx) => {
              const isLastItem = idx === data.length - 1;
              return (
                <div key={gamer.position} ref={isLastItem ? ref : null}>
                  {' '}
                  <PlayerRowItem gamer={gamer}/>
                </div>
              );
            })}
          </VerticalView>
        </>
      )}
    </LeaderBoardWrapper>
  );
};

interface PlayerRowItemProps {
  gamer: BonusTreeInfoDto;
}

const PlayerRowItem = ({ gamer }: PlayerRowItemProps) => {
  return (
    <PlayerRowItemWrapper>
      <HorizontalView style={{ gap: 12 }}>
        <MedalWrapper>
          {getMedalIcon(Number(gamer.position))}

          <MedalPosition
            style={{
              color: Number(gamer.position) > 2 ? '#fff' : 'rgba(0, 0, 0, 0.8)',
            }}>
            {Number(gamer.position)}
          </MedalPosition>
        </MedalWrapper>
        <GamerName>{gamer.bonusTreeName}</GamerName>
      </HorizontalView>
      <HorizontalView style={{ gap: 4 }}>
        <CoinIcon width={12} height={12}/>
        <BonusAmount>{gamer.rating}</BonusAmount>
      </HorizontalView>
    </PlayerRowItemWrapper>
  );
};
